import { z } from 'zod';
const VersionCheckResultsInboundSchema = z
    .object({
    isClientVersionOk: z.boolean()
})
    .transform(
// add _type
({ ...rest }) => ({
    _type: 'version_check_results',
    ...rest
}));
export const VERSION_CHECK_RESULTS_PAYLOAD_DEFINITION = {
    zodSchema: VersionCheckResultsInboundSchema
};
